import React from "react"
import { formatText } from "../../../v1/helpers/stringHelpers"
import FuelFeatureDetails from "./FuelFeatureDetails"
import { useTranslation } from "react-i18next"
import { Button } from "semantic-ui-react"

const FeatureList = ({
  sectionHeader,
  featureList,
  alignInOneRow,
  hideFuelButtonInMobile,
  buttonClick
}) => {
  const { t } = useTranslation("fuelcardRequest")

  return (
    <div className="feature-section-1">
      <p className="feature-list-header">
        {formatText(sectionHeader, "feature-list-header-orange")}
      </p>
      <div className={`${alignInOneRow ? "feature-list2-grid" : "feature-list-grid"}`}>
        {featureList.map((feature, index) => (
          <FuelFeatureDetails key={feature.image} feature={feature} step={index + 1} />
        ))}
      </div>
      <div className={`get-fuel-action ${hideFuelButtonInMobile ? "hide" : ""}`}>
        <Button onClick={buttonClick} className="get-my-fuel-card">
          {t("getMyFuelCard")}
        </Button>
      </div>
    </div>
  )
}

export default FeatureList
